<template>
  <div class="teen-page teen1">
    <div class="header">
      <h1>青蒿素之母：屠呦呦</h1>
    </div>

    <div class="container">
      <div class="img-box">
        <img src="https://img.moliaos.com/v/teen/teen_1.png" alt="屠呦呦">
        <div class="caption">屠呦呦研究员，首位获得诺贝尔科学奖的中国本土科学家</div>
      </div>

      <h2>一、 使命的召唤</h2>
      <p>屠呦呦，中国中医科学院首席科学家，青蒿素研究开发中心主任。2015年，她因发现青蒿素获得诺贝尔生理学或医学奖，成为第一位获得诺贝尔科学奖项的中国本土科学家。青蒿素的发现，为全球抗疟事业做出了不可磨灭的贡献。</p>

      <h2>二、 从传统中寻找答案</h2>
      <p>20世纪60年代，疟疾在全球范围内肆虐。中国政府启动了抗疟药物研究项目。屠呦呦带领团队从中国传统医学典籍中寻找灵感，系统筛选了2000多种中草药，最终发现青蒿具有抗疟效果。但最初的实验并不顺利，青蒿提取物的效果不稳定。</p>

      <div class="img-box">
        <img src="https://img.moliaos.com/v/teen/teen_1.png" alt="青蒿">
        <div class="caption">青蒿，一种看似普通的草本植物，却蕴含着拯救生命的力量</div>
      </div>

      <h2>三、 关键时刻的灵感</h2>
      <p>在研究陷入困境时，屠呦呦从东晋葛洪的《肘后备急方》中获得启发："青蒿一握，以水二升渍，绞取汁，尽服之。"这句话提示她改用低温提取方法。经过无数次实验，她终于在1971年成功提取出青蒿素，并证明其对疟原虫具有100%的抑制率。</p>

      <div class="quote-box">
        "青蒿素是传统中医药送给世界人民的礼物。" —— 屠呦呦
      </div>

      <h2>四、 拯救百万生命</h2>
      <p>青蒿素类药物的问世，使全球疟疾死亡率下降了50%，挽救了数百万患者的生命，尤其在非洲地区。世界卫生组织将青蒿素类药物列为抗疟首选药物，屠呦呦的研究成果真正实现了"把论文写在大地上"。</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Teen1'
}
</script>

<style scoped>
.teen-page {
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  margin: 0;
  background: #f0f5f0;
  line-height: 1.8;
}

.header {
  background: linear-gradient(135deg, #1e3a5f 0%, #2d5a87 100%);
  color: white;
  padding: 30px 20px;
  text-align: center;
}

.container {
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;
}

h1 {
  margin: 0;
  font-size: 1.6rem;
}

h2 {
  color: #1e3a5f;
  border-bottom: 2px solid #4a90c2;
  padding-bottom: 8px;
  margin-top: 30px;
  font-size: 1.2rem;
}

p {
  text-indent: 2em;
  margin-bottom: 20px;
  text-align: justify;
}

.img-box {
  text-align: center;
  margin: 25px 0;
}

.img-box img {
  width: 100%;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0,0,0,0.1);
}

.caption {
  font-size: 0.85rem;
  color: #666;
  margin-top: 10px;
}

.quote-box {
  background: #e3f2fd;
  padding: 20px;
  border-left: 4px solid #1e3a5f;
  margin: 25px 0;
  font-style: italic;
  color: #333;
}
</style>